import { useState, useEffect } from "react";
import { Clock2, MapPinXInside } from "lucide-react";
import "./App.css";

const Geolocation = () => {
  const [coords, setCoords] = useState({ latitude: null, longitude: null });
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!navigator.geolocation) {
      setError("Geolocalização não é suportada pelo navegador.");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        setCoords({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });
      },
      () => {
        setError("Não foi possível obter a localização.");
      }
    );
  }, []);

  return (
    <div className="App-header">
      {error && (
        <div className="information-container">
          <div className="information-icon-container-error">
            <MapPinXInside className="information-icon-error" />
          </div>
          {error}
        </div>
      )}
      {coords.latitude && coords.longitude ? (
        <div className="container-label-input">
          <p className="label" style={{ marginBottom: 0 }}>
            Geolocalização
          </p>
          <input
            type={"text"}
            className="input"
            value={`${coords.latitude}, ${coords.longitude}`}
            disabled={true}
            placeholder={""}
          />
        </div>
      ) : (
        !error && (
          <div className="information-container">
            <div className="information-icon-container">
              <Clock2 className="information-icon" />
            </div>
            Realizando busca ...
          </div>
        )
      )}
    </div>
  );
};

export default Geolocation;
